export { CurrencyFormatType } from '../types/prism';
export var AXIS_TYPES;
(function (AXIS_TYPES) {
    AXIS_TYPES["X"] = "X";
    AXIS_TYPES["Y"] = "Y";
    AXIS_TYPES["COLOR"] = "COLOR";
})(AXIS_TYPES || (AXIS_TYPES = {}));
export var FormatterTypeEnum;
(function (FormatterTypeEnum) {
    FormatterTypeEnum[FormatterTypeEnum["GENERIC_FORMATTER"] = 0] = "GENERIC_FORMATTER";
    FormatterTypeEnum[FormatterTypeEnum["NUMERIC_FORMATTER"] = 1] = "NUMERIC_FORMATTER";
    FormatterTypeEnum[FormatterTypeEnum["GEO_FORMATTER"] = 2] = "GEO_FORMATTER";
    FormatterTypeEnum[FormatterTypeEnum["DATE_FORMATTER"] = 3] = "DATE_FORMATTER";
    FormatterTypeEnum[FormatterTypeEnum["DATE_NUM_FORMATTER"] = 4] = "DATE_NUM_FORMATTER";
    FormatterTypeEnum[FormatterTypeEnum["TIME_FORMATTER"] = 5] = "TIME_FORMATTER";
})(FormatterTypeEnum || (FormatterTypeEnum = {}));
//# sourceMappingURL=types.js.map